const preScanFR = {
    "form": {
        "modal": {
            "preScanResults": {
                "header": "Résultats du Pré-Scan",
                "body": {
                    "description": "Les résultats suivants ont été trouvés après avoir effectué le scan pour cette sortie. Veuillez les vérifier en détail :",
                    "table": {
                        "column": {
                            "trackName": "Nom de la piste",
                            "type": "Type",
                            "title": "Titre",
                            "artists": "Artistes",
                            "album": "Album",
                            "label": "Maison de disques",
                            "releaseDate": "Date de sortie",
                            "score": "Note (%)"
                        },
                    },
                    "label": {
                        "flaggedTracks": "Pistes Signalées",
                        "music": "Musique",
                        "cover": "Reprise",
                        "signDeclaration": "Veuillez signer la déclaration pour continuer.",
                        "cancelRelease": "Je souhaite annuler cette sortie.",
                        "approveRelease": {
                            "point1": "Je souhaite approuver cette sortie parce que les résultats affichés sont 100% identiques à ma propre sortie / transférée depuis le distributeur précédent.",
                            "point2": "Je déclare solennellement, sous la peine de perjury, que tout contenu que je fournis est propriété de ma société ou de moi, ou que je détiens des droits et licences complets et valides nécessaires pour son utilisation, distribution et soumission.",
                            "point3": "Je reconnais et accepte que je suis entièrement responsable de toutes les conséquences légales qui peuvent survenir de la soumission de tel contenu, y compris mais sans s'y limiter aux procédures judiciaires, réclamations, coûts et frais.",
                            "point4": "Je comprends et accepte que mes données personnelles, y compris les informations KYC et toutes autres données pertinentes, peuvent être partagées avec des partenaires autorisés, fournisseurs de services numériques (DSPs), tiers impliqués dans le traitement de tel contenu, ainsi que les tribunaux, autorités réglementaires et agences de justice en cas de tout recours, litige ou exigence légale.",
                            "point5": "Je comprends et accepte que Music Link a le droit de immédiatement mettre fin à mon accord, sans aucune compensation ou obligation supplémentaire, si il est prouvé que j'ai abusé de ce formulaire ou si une partie de ma déclaration est fausse, trompeuse ou mal représentée.",
                        },
                        "noFlaggedTracks": "Aucune piste signalée détectée dans le pré-scan, vous pouvez continuer avec les étapes suivantes !"
                    },
                    "help_text": {
                    },
                },
                "button": {
                    "submit": "Soumettre",
                    "close": "Fermer"
                }
            },
            "performScan": {
                "header": "Effectuer le Pré-Scan",
                "body": "Veuillez confirmer que vous voulez effectuer le pré-scan pour cette sortie.",
                "button": {
                    "cancel": "Annuler",
                    "performScan": "Effectuer le Scan"
                }
            }
        },
        "message": {
            "releaseDistributionCancelled": "Vous avez annulé la distribution de la sortie, par conséquent elle a été retirée.",
            "admin_pending": "Votre déclaration est en attente de révision par l'administrateur pour prendre des mesures supplémentaires.",
            "admin_approved": "Votre demande de distribution de votre sortie a été approuvée par notre équipe d'administration. La sortie a étéIconSuccessfully verified. We appreciate your diligence in ensuring accuracy and compliance. The release will proceed to all stores as planned. Thank you for your attention to detail and adherence to our standards.",
            "admin_rejected": "Votre demande de distribution de votre sortie a été rejetée. Après une révision attentive, la demande ne répond pas à nos exigences d'approbation. Nous recommandons de réévaluer le contenu et de nous assurer que toutes les conditions et implications légales sont prises en compte. Merci pour votre compréhension et votre coopération.",
            "scanInProgress": "Scan en cours, veuillez patienter jusqu'à la fin du scan.",
            "releaseMustBeReady": "La sortie doit être en statut Ready pour effectuer le pré-scan.",
            "errorSubmittingDeclaration": "Une erreur est survenue lors de la soumission de la déclaration de l'administrateur du pré-scan.",
        }
    }
};

export default preScanFR;